module.exports = __webpack_public_path__ + "img/autoplay.12b5002a.svg";